/**
* 左边菜单
*/
<template>
  <el-menu :collapse="collapsed" :default-openeds="['数据统计']" collapse-transition router :default-active="$route.path" unique-opened class="el-menu-vertical-demo" background-color="#ffffff" text-color="#7c8da5" active-text-color="#347ae2" @open="handleOpen">
    <div style="height:20px">
    </div>
    <el-menu-item  :index="menu.url" v-for="(menu,index) in allmenu" v-if="!menu.child" :key="index">
      <i  class="element-icons" :class="menu.icon"></i>
      <span>{{menu.title}}</span>
    </el-menu-item>
    <el-submenu :index="menu.title" v-else >
      <template slot="title">
        <i class="element-icons" :class="menu.icon"></i>
        <span style="display: inline-block;margin-top: -2px">{{menu.title}}</span>
      </template>

      <el-menu-item-group v-for="(menu_child,index2) in menu.child" :key="index2" index="indexaaa" class="zhankai">
        <el-menu-item :index="menu_child.url" style="height: 36px;line-height: 36px">
          <span style="font-size: 14px;margin-left: 6px">{{menu_child.title}}</span>
        </el-menu-item>
      </el-menu-item-group>
    </el-submenu>

  </el-menu>
</template>
<script>
// import {getMenu} from "../api/userMG";

export default {
  name: 'leftnav',
  data() {
    return {
      collapsed: false,
      allmenu: [
        {title:'项目管理',url:'/share/current',icon:'el-icon-liebiao'},
        {title:'数据统计',icon:'el-icon-leimupinleifenleileibie2',child:[
            {title:'部门商洽效率分析',url:'/state/depart'},
            {title:'合同执行效率分析',url:'/state/bid'},
            {title:'经营销量分析',url:'/state/sales'}
          ]},
        {title:'部门管理',url:'/share/department',icon:'el-icon-biaoqian'},
        {title:'员工管理',url:'/user/user',icon:'el-icon-yonghu'},

      ]
    }
  },
  methods:{
    handleOpen(key, keyPath) {
      this.activeDefault = keyPath;
      // console.log(key, keyPath);
    },
  },
  // 创建完毕状态(里面是操作)
  created() {
    this.$root.Bus.$on('toggle', value => {
      this.collapsed = !value
    })
  },
  mounted() {
    // this.getMenuList()
  }
}
</script>
<style>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  border: none;
  text-align: left;
}
.el-menu-item-group__title {
  padding: 0px;
}
.el-menu-bg {
  background-color: #0f215d !important;
}

.el-menu {
  border: none;

}
.logobox {
  /* position: absolute; */
  height: 50px;
  line-height: 50px;
  color: #9d9d9d;
  font-size: 20px;
  background-color: #25396f;
  text-align: center;
  /* padding: 20px 0px; */
}
.el-menu-item.is-active{
  color: #347ae2 !important;
  font-weight: 600;
  font-stretch: normal;
}
.el-menu-item.is-active::before{
  content: ' ';
  border-right: 4px solid #347ae2;
  display: inline-block;
  height: 26px;
  position: absolute;
  border-radius: 20px;
  /* top: 50%; */
  /* left: 0; */
  right: 1px;
  /* margin-top: -13px; */
}
.zhankai >>> .el-menu-item.is-active::before{
  content: ' ';
  border-right: 4px solid #347ae2;
  display: inline-block;
  height: 26px;
  position: absolute;
  border-radius: 20px;
  /* top: 50%; */
   left: 165px!important;
  /*right: 1px;*/
  /* margin-top: -13px; */
}

.el-menu-item, .el-submenu__title,
.el-submenu .el-menu-item{
  height: 42px;
  line-height: 42px;

}
.el-submenu__title{
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #347ae2;
  letter-spacing: 0px;
  color: #7c8db5;
  align-items: center;
}
.el-menu-item{
  display: flex;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #347ae2;
  letter-spacing: 0px;
  color: #7c8db5;
  align-items: center;
}
.el-menu-item:hover{
  background: #fff !important;
  color: #347ae2 !important;
}
.el-menu-item:hover i{
  color: #347ae2 !important;
}
.el-submenu__title:hover{
  background: #fff !important;
  color: #347ae2 !important;
}
.el-submenu__title:hover i{
  color: #347ae2 !important;
}
.element-icons{
  margin-right: 12px;
}
.el-menu-item i{
  color: #7c8db5;
}
.el-submenu__title i{
  color: #7c8db5;
  font-size: 16px;
}
.el-submenu__title i{
  margin-right: 6px;
}
.el-submenu .el-menu-item{
  min-width: 200px!important;
}
</style>



// WEBPACK FOOTER //
// src/components/leftnav.vue